import {CrudModel} from '@ngx-ivengi/crud';
import {User} from '../user/user.model';

export class Device extends CrudModel {

  public UDID: string;
  public employeeId: string;
  public employee: User;
  public description: string;

  public setUDID(udid: string): Device {
    if(typeof udid === 'string') {
      this.UDID = udid;
    }
    return this;
  }

  public setEmployeeId(employeeId: string): Device {
    if(typeof employeeId === 'string') {
      this.employeeId = employeeId;
    }
    return this;
  }

  public setEmployee(employee: User): Device {
    this.employee = employee;
    return this;
  }

  public setDescription(description: string): Device {
    if(typeof description === 'string') {
      this.description = description;
    }
    return this;
  }

  fromResponse(response: any): void {
    this
      .setId(response.id)
      .setUDID(response.UDID)
      .setEmployee(response.employee)
      .setEmployeeId(response.employeeId)
      .setDescription(response.description);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/device/device.model.ts